export default {
  acceleratorTeam: {},
  isLoading: false,
  errors: null,
};
